import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];

  connect() {
    this.showTab();
  }

  change(e) {
    this.index = this.tabTargets.indexOf(e.currentTarget);
    this.showTab();
  }

  showTab() {
    const company_elem = document.getElementById("new_company_tab");
    const exts_company_elem = document.getElementById("exts_company");

    if (this.index == 0) {
      company_elem.style.display = "block";
      exts_company_elem.style.display = "none";
    } else {
      company_elem.style.display = "none";
      exts_company_elem.style.display = "block";
    }

    this.removeAndAddClasses();
  }

  removeAndAddClasses() {
    this.tabTargets.forEach((el, i) => {
      if (i == this.index) {
        el.classList.add("Companies__Tabs__TabbedNavItem--active");
      } else if (this.index == -1) {
        return;
      } else {
        el.classList.remove("Companies__Tabs__TabbedNavItem--active");
      }
    });
  }

  get index() {
    return parseInt(this.data.get("index"));
  }

  set index(value) {
    this.data.set("index", value);
    this.showTab();
  }
}
